import React, {
  useContext,
  useState,
  useEffect,
  useCallback,
  useMemo,
  useRef,
} from "react";
import Modal from "react-modal";
import format from "date-fns/format";
import dynamic from "next/dynamic";
const Lottie = dynamic(() => import("lottie-react-web"), { ssr: false });
import Confetti from "react-confetti";
// import {circularProgress, LockIcon, TimeSlotNotAvailable} from "../../public/assets";
// import { db } from "../../../firebase_config";
import Drawer from "@material-ui/core/Drawer";
import { loadScript } from "../../helpers";
import { castIndianTime } from "../../helpers/getIndianTime";
import CloseIcon from "@material-ui/icons/Close";
import { useMediaQuery } from "react-responsive";
import CancelIcon from "@material-ui/icons/Cancel";
import Image from "next/image";
// TODO: Refactor react-use library
import useWindowSize from "react-use/lib/useWindowSize";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import {
  ThemeContext,
  IntroContext,
  UserContext,
  PustackProContext,
} from "../../context";
import ScholarshipPageLight from "../../public/assets/images/scholarship_page_background_light.svg";
import ScholarshipPageDark from "../../public/assets/images/scholarship_page_background_dark.svg";
import ScholarshipSuccessLottie from "../../public/assets/lottie/scholarship_success-1.json";

import FileCopyOutlinedIcon from "@material-ui/icons/FileCopyOutlined";
import {
  EmailIcon,
  EmailShareButton,
  FacebookIcon,
  FacebookShareButton,
  TelegramIcon,
  TelegramShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from "react-share";

import { referralImage } from "../../public/assets";

import PuStackWhiteLogo from "../../public/assets/images/logoDark.webp";
import PuStackLightLogo from "../../public/assets/images/logo.webp";
import circleProg from "../../public/assets/lottie/circularProgress.json";
import CheckCircleIcon from "../../public/assets/images/icons/check-circle.svg";
import { ErrorOutline, LibraryBooks, School } from "@material-ui/icons";
import Carousel from "react-material-ui-carousel";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import SwipeableViews from "react-swipeable-views";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import DateFnsUtils from "@date-io/date-fns";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { SessionFormSelect } from "../../components/livesession/SessionFormInput";
import { getAvailableGrades } from "../../helpers";
import useForm, { Validators } from "../../hooks/form";
import PustackButton from "../../components/global/PustackButton";
import { Dialog } from "@material-ui/core";
// import {ScholarshipInput} from "./scholarship-input";
import useStandardGrade from "../../hooks/isStandardGrade";
import useInBrowser from "../../hooks/useInBrowser";
import { generateInvitationLink } from "../../database";
import AcceptedScreen from "../../components/global/Scholarship/AcceptedScreen";
import UnderReviewScreen from "../../components/global/Scholarship/UnderReviewScreen";
import DeniedScreen from "../../components/global/Scholarship/DeniedScreen";
import ScholarshipForm from "../../components/global/Scholarship/ScholarshipForm";
import CongratulationScreen, {
  PostReceiptData,
} from "./ProSlider/CongratulationScreen";
import ProcessingPaymentScreen from "./ProSlider/ProcessingPaymentScreen";

const BrandLogoLight =
  "https://firebasestorage.googleapis.com/v0/b/avian-display-193502.appspot.com/o/scholarship%2Fjeet_foundation_light.png?alt=media&token=d4257dc5-e5bc-49e9-b7ae-6fd1dceee778";
const BrandLogoDark =
  "https://firebasestorage.googleapis.com/v0/b/avian-display-193502.appspot.com/o/scholarship%2Fjeet_foundation_dark.png?alt=media&token=e3e80595-c74b-489b-a0b8-aae6fd88f72e";

// Commented out code will be used later, when the embargo is lifted
const createDoubtOrder = async ({ planId, userId, userGrade }) => {
  // const createProOrderFunction = require('../../firebase-config').functions.httpsCallable("createProOrder");
  const createDoubtOrderFunction =
    require("../../firebase-config").functions.httpsCallable(
      "createDoubtOrderTest"
    );

  console.log("planId - ", planId);

  const response = await createDoubtOrderFunction({
    plan_id: planId,
    user_id: userId,
    user_grade: userGrade,
  });

  return response?.data;
};

export const formatDoubtCount = (count: number) => {
  // If count is less than 1000, return the count
  if (count < 1000) return count;

  // If count is greater than 1000, return Unlimited
  return "Unlimited";
};

const getPlans = async () => {
  return await require("../../firebase-config")
    .db.collection("products")
    .doc("doubts")
    .get()
    .then((doc) => doc.data().plans)
    .catch((_) => null);
};

function formatPhoneNumber(value) {
  // if input value is falsy eg if the user deletes the input, then just return
  if (!value) return value;

  // clean the input for any non-digit values.
  const phoneNumber = value.replace(/[^\d]/g, "");

  // phoneNumberLength is used to know when to apply our formatting for the phone number
  const phoneNumberLength = phoneNumber.length;

  // we need to return the value with no formatting if its less then four digits
  // this is to avoid weird behavior that occurs if you  format the area code to early

  if (phoneNumberLength < 6) return phoneNumber;

  // console.log('phone number - ', phoneNumber, `${phoneNumber.slice(0, 5)} ${phoneNumber.slice(5)}`);

  // if phoneNumberLength is greater than 4 and less the 7 we start to return
  // the formatted number
  // if (phoneNumberLength < 7) {
  return `${phoneNumber.slice(0, 5)} ${phoneNumber.slice(5, 10)}`;
  // }

  // finally, if the phoneNumberLength is greater then seven, we add the last
  // bit of formatting and return it.
  // return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
  //   3,
  //   6
  // )}-${phoneNumber.slice(6, 10)}`;
}

const ScholarshipInput = ({
  value,
  onChange,
  invalidKeys,
  className,
  placeholder = "Type here...",
  name,
  type = "text",
  ...props
}) => {
  // function handleChange(e) {
  //   onTextChange(e.target.value);
  //   typeof onChange === 'function' && onChange(e);
  // }

  return (
    <div
      className={
        "scholarship-form-input " +
        (className ?? "") +
        (invalidKeys.includes(name) ? " error" : "")
      }
    >
      <input
        value={value}
        name={name}
        onChange={onChange}
        type={type}
        {...props}
      />
      <label htmlFor="">{placeholder}</label>
    </div>
  );
};

interface ScholarshipConstructorParams {
  uid: string;
  forceUpdate: React.Dispatch<React.SetStateAction<number>>;
}

type ScholarshipStatus = "under_review" | "approved" | "rejected" | "abandoned";

type grade = `class_${number}`;

type date = `${number}/${number}/${number}`;

interface DataMap {
  [key: grade]: string;
}

export interface ScholarshipDocumentData {
  applied_on?: number;
  first_name: string;
  grade: grade;
  date_of_birth: date;
  id?: string;
  last_name: string;
  marks_map: DataMap;
  organisation_name: string;
  phone_number: string;
  previous_application_id: string | null;
  school_name: string;
  status: ScholarshipStatus;
  uid: string;
}

export class Scholarship {
  private _status: string;

  private _UNDER_REVIEW: boolean;
  private _ABANDONED: boolean;
  private _APPROVED: boolean;
  private _REJECTED: boolean;

  private _submitting: boolean;
  private _lastApplication: ScholarshipDocumentData;
  private _data: ScholarshipDocumentData;
  private _uid: string;
  private _init: boolean;

  private readonly forceUpdate: () => void;

  private set UNDER_REVIEW(status) {
    this._UNDER_REVIEW = status;
  }
  private set ABANDONED(status) {
    this._ABANDONED = status;
  }
  private set APPROVED(status) {
    this._APPROVED = status;
  }
  private set REJECTED(status) {
    this._REJECTED = status;
  }

  public get UNDER_REVIEW() {
    return this._UNDER_REVIEW;
  }
  public get ABANDONED() {
    return this._ABANDONED;
  }
  public get APPROVED() {
    return this._APPROVED;
  }
  public get REJECTED() {
    return this._REJECTED;
  }

  private set status(status) {
    this._status = status;
  }
  public get status() {
    return this._status;
  }

  private set submitting(submitting) {
    this._submitting = submitting;
  }
  public get submitting() {
    return this._submitting;
  }

  private set uid(uid) {
    this._uid = uid;
  }

  public get uid() {
    return this._uid;
  }

  private set initialized(init) {
    this._init = init;
  }

  public get initialized() {
    return this._init;
  }

  private set data(data) {
    this._data = data;
  }

  public get data() {
    return this._data;
  }

  private set lastApplication(lastApplication) {
    this._lastApplication = lastApplication;
  }

  public get lastApplication() {
    return this._lastApplication;
  }

  constructor({ uid, forceUpdate }: ScholarshipConstructorParams) {
    this.uid = uid;
    this.forceUpdate = () => {
      forceUpdate((c) => c + 1);
    };
  }

  async init() {
    this.lastApplication = await this.fetchLastApplication();
    this.refreshStatus();

    this.forceUpdate();
    this.initialized = true;
  }

  private refreshStatus() {
    this.status = this.lastApplication?.status ?? "abandoned";
    this.UNDER_REVIEW = this.status === "under_review";
    this.ABANDONED = this.status === "abandoned";
    this.APPROVED = this.status === "approved";
    this.REJECTED = this.status === "rejected";
  }

  private async fetchLastApplication() {
    const querySnapshot = await require("../../firebase-config")
      .db.collection("scholarships")
      .where("uid", "==", this.uid)
      .orderBy("applied_on", "desc")
      .limit(1)
      .get();

    return querySnapshot.docs[0]?.data();
  }

  async applyAgain() {
    if (!this.lastApplication)
      throw new Error("There is no previous application.");
    this.submitting = true;
    const docRef = require("../../firebase-config")
      .db.collection("scholarships")
      .doc(this.lastApplication?.id);

    await docRef.set(
      {
        status: "abandoned",
      },
      { merge: true }
    );
    this.lastApplication.status = "abandoned";
    this.refreshStatus();
    this.submitting = false;

    this.forceUpdate();
  }

  async apply(data: ScholarshipDocumentData | undefined) {
    this.submitting = true;
    this.forceUpdate();

    const docRef = require("../../firebase-config")
      .db.collection("scholarships")
      .doc();

    const ist = await castIndianTime(true);

    const obj = data;

    obj.applied_on = +ist;
    obj.id = docRef.id;
    if (this.lastApplication)
      obj.previous_application_id = this.lastApplication.id;

    await docRef.set(obj);

    this.lastApplication = obj;
    this.refreshStatus();
    this.submitting = false;
    this.forceUpdate();
  }
}

enum PAYMENT_STATUS {
  "AUTHORIZED" = "authorized",
  "PROCESSING" = "processing",
  "CAPTURED" = "captured",
}

export default function PustackProSlider() {
  const [plans, setPlans] = useState([
    {
      is_recommended: false,
      plan_duration: 1,
      plan_name: "1-month Plan",
      plan_price: 5999,
      serial_order: 0,
    },
  ]);
  const [isOpen, setProSliderOpen] = useContext(PustackProContext).doubtValue;
  const proSubscriptionJourneyRef =
    useContext(IntroContext).proSubscriptionJourneyRef;
  const [orderId, setOrderId] = useState(null);
  const [planIndex, setPlanIndex] = useState(0);
  const [referralLink, setReferralLink] = useState("");
  const [orderStatus, setOrderStatus] = useState<
    boolean | "payment_cancelled" | "payment_failed"
  >(false);
  const [generatingLink, setGeneratingLink] = useState(false);
  const [proOrderCreating, setProOrderCreating] = useState(false);
  const [openCriteriaModal, setOpenCriteriaModal] = useState(false);
  const [openSharableModal, setOpenSharableModal] = useState(false);
  const inBrowser = useInBrowser();
  const [activeIndex, setActiveIndex] = useState(0);
  const [
    isUserAlreadyAppliedForScholarship,
    setIsUserAlreadyAppliedScholarship,
  ] = useState(null);
  const [date, handleDate] = useState(null);
  const [phone, setPhone] = useState("");
  const [user] = useContext(UserContext).user;
  const [isSubmittingApplication, setIsSubmittingApplication] = useState(false);
  const [runConfetti, setRunConfetti] = useState(false);
  const [openDatePicker, setOpenDatePicker] = useState(false);
  const [invalidKeys, setInvalidKeys] = useState([]);
  const formRef = useRef(null);
  const [, setRefresh] = useState(0);
  const orderStatusRef = useRef(null);
  const [touched, setTouched] = useState(false);
  const { register, handleChange, form, changeIndex } = useForm({
    firstName: ["", [Validators.req()]],
    lastName: ["", [Validators.req()]],
    phone: [
      "",
      [
        Validators.req(),
        Validators.minLenFormattedValue(10),
        Validators.maxLenFormattedValue(10),
      ],
    ],
    schoolName: ["", [Validators.req()]],
    // dob: [null, [Validators.req()]],
    grade: [user?.grade || "", [Validators.req()]],
  });
  const isStandardGrade = useStandardGrade();
  const scholarshipRef = useRef<Scholarship>({});
  const scholarshipJourneyRef = useContext(IntroContext).scholarshipJourneyRef;

  const [isDark] = useContext(ThemeContext).theme;
  const [isUserPro] = useContext(UserContext).tier;

  const { width, height } = useWindowSize();
  const [postReceiptData, setPostReceiptData] =
    useState<PostReceiptData | null>(null);
  const [paymentStatus, setPaymentStatus] = useState<PAYMENT_STATUS | null>(
    null
  );

  useEffect(() => {
    if (!user?.uid) return;
    scholarshipRef.current = new Scholarship({
      uid: user.uid,
      forceUpdate: setRefresh,
    });

    window.scholarship = scholarshipRef.current;

    scholarshipRef.current.init();
  }, [user]);

  useEffect(() => {
    scholarshipRef.current && scholarshipRef.current.init();

    if (!isOpen) {
      setPostReceiptData(null);
      setPaymentStatus(null);
      setOrderStatus(false);
    }
  }, [isOpen]);

  const handleClose = () => {
    setProSliderOpen(false);
    checkIfUserApplied();
  };

  useEffect(() => {
    if (user) {
      getPlansFn();
    }
  }, [user?.pro_expiration_date, user?.uid, isOpen]);

  useEffect(() => {
    orderStatusRef.current = orderStatus;
  }, [orderStatus]);

  useEffect(() => {
    if (
      isOpen &&
      proSubscriptionJourneyRef &&
      proSubscriptionJourneyRef.current &&
      !orderStatusRef.current
    ) {
      proSubscriptionJourneyRef.current.logEvent("has_shown_pro_plans");
    }
  }, [proSubscriptionJourneyRef, isOpen]);

  useEffect(() => {
    if (!proSubscriptionJourneyRef || !proSubscriptionJourneyRef.current)
      return () => {};
    if (orderStatus === "payment_cancelled") {
      proSubscriptionJourneyRef.current.logEvent(
        "remove_from_cart",
        null,
        "add_to_cart"
      );
    } else if (orderStatus) {
      proSubscriptionJourneyRef.current.logEvent(
        "purchase",
        null,
        "add_to_cart"
      );
    }
  }, [proSubscriptionJourneyRef, orderStatus]);

  useEffect(() => {
    if (activeIndex === 3) setRunConfetti(true);
  }, [activeIndex]);

  // useEffect(() => {
  //   let el = formRef.current;
  //   if(invalidKeys && el) {
  //     if(!el[invalidKeys]) return;
  //     el[invalidKeys].focus();
  //   }
  // }, [invalidKeys, formRef])

  const validateInputs = (withFocus) => {
    form.validate();
    form.update();
    let keys = [];

    let errorKeys = Object.keys(form.errors),
      focused = false;
    for (let i = 0; i < errorKeys.length; i++) {
      let isThere = formRef.current[errorKeys[i]] && form.errors[errorKeys[i]];
      if (isThere) {
        keys.push(errorKeys[i]);
        if (!focused && withFocus) formRef.current[errorKeys[i]].focus();
        focused = true;
        // break;
      } else {
        keys = keys.filter((c) => c !== errorKeys[i]);
      }
    }

    if (!date) {
      keys.push("dob");
    } else {
      keys = keys.filter((c) => c !== "dob");
    }

    setInvalidKeys(keys);
    return keys.length === 0;
  };

  useEffect(() => {
    if (!touched) return;
    validateInputs();
  }, [changeIndex, touched, date]);

  const handleSubmit = async () => {
    // setInvalidKey('schoolName')

    const isValid = validateInputs(true);
    setTouched(true);

    if (!isValid) return;

    setIsSubmittingApplication(true);

    const ist = await castIndianTime();

    const dob = format(date, "dd/LL/yyyy");

    const docRef = require("../../firebase-config")
      .db.collection("scholarships")
      .doc();

    const controls = Object.keys(form.controls).filter((c) =>
      c.startsWith("class_")
    );

    let gradeMarks = controls.reduce((acc, key) => {
      acc[key] = form.get(key).value;
      return acc;
    }, {});

    const obj: ScholarshipDocumentData = {
      applied_on: +ist,
      // @ts-ignore
      date_of_birth: dob,
      first_name: form.get("firstName").value,
      grade: form.get("grade").value,
      id: docRef.id,
      last_name: form.get("lastName").value,
      // @ts-ignore
      marks_map: gradeMarks,
      organisation_name: "Jeet Foundation",
      phone_number: form.get("phone").value,
      school_name: form.get("schoolName").value,
      status: "under_review",
      previous_application_id: null,
      uid: user.uid,
    };

    await docRef.set(obj);

    setIsSubmittingApplication(false);
    setActiveIndex(3);
  };

  function checkIfUserApplied(cb = () => {}) {
    require("../../firebase-config")
      .db.collection("scholarships")
      .where("uid", "==", user?.uid)
      .get()
      .then((snapshot) => {
        if (snapshot.docs.length > 0) {
          const doc = snapshot.docs[0].data();
          setIsUserAlreadyAppliedScholarship(doc);
          handleChange({
            target: { name: "firstName", value: doc.first_name },
          });
          handleChange({ target: { name: "lastName", value: doc.last_name } });
          handleChange({ target: { name: "phone", value: doc.phone_number } });
          handleChange({
            target: { name: "schoolName", value: doc.school_name },
          });
          handleChange({ target: { name: "grade", value: doc.grade } });
          console.log("doc.marks_map - ", doc.marks_map);
          for (let key in doc.marks_map) {
            console.log("key and value is - ", key, doc.marks_map[key]);
            handleChange({ target: { name: key, value: doc.marks_map[key] } });
          }
          handleDate(doc.date_of_birth);
          setPhone(doc.phone_number);
          cb();
        } else {
          setIsUserAlreadyAppliedScholarship(false);
        }
      });
  }

  useEffect(() => {
    if (!user?.uid) return;
    checkIfUserApplied();
  }, [user?.uid, handleChange]);

  const gradeItems = useMemo(() => {
    const availableGrades = getAvailableGrades(false, true);
    return availableGrades.map((c) => ({
      id: c.grade,
      value: c.value,
      label: c.grade,
    }));
  }, []);

  const handlePhoneChange = (e) => {
    let formattedValue = formatPhoneNumber(e.target.value);

    handleChange({ target: { name: e.target.name, value: formattedValue } });

    setPhone(formattedValue);
  };

  const commaSeperated = (x) => {
    if (x) {
      x = x.toString();
      let lastThree = x.substring(x.length - 3);
      let otherNumbers = x.substring(0, x.length - 3);
      if (otherNumbers !== "") lastThree = "," + lastThree;
      let res = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;
      return res;
    } else return 0;
  };

  const getPlansFn = async () => {
    const result = await getPlans();
    let _plans = [];

    for (let plan in result) {
      _plans.push({
        planId: plan,
        name: result[plan].plan_name,
        price: "₹" + commaSeperated(result[plan].plan_price),
        introductoryPrice: "₹" + commaSeperated(result[plan].crossed_price),
        // validity: calculateDate(result[plan].plan_duration),
        is_recommended: result[plan].is_recommended,
        serial_order: result[plan].serial_order,
      });

      if (result[plan].is_recommended) {
        setPlanIndex(result[plan].serial_order);
      }
    }
    _plans.sort((a, b) => a.serial_order - b.serial_order);
    setPlans(_plans);
    // setPlanIndex(_plans.length - 1)
  };

  useEffect(() => {
    const orderStatusListener = () => {
      const doc = require("../../firebase-config")
        .db.collection("orders")
        .doc(orderId);

      return doc.onSnapshot((docSnapshot) => {
        const { payment_status, ...data } = docSnapshot.data();

        console.log("data - ", data, payment_status);

        if (data.transaction_status === "payment_authorized") {
          setProSliderOpen(true);
          setPaymentStatus(PAYMENT_STATUS.AUTHORIZED);
        }

        if (data.transaction_status === "created") {
          // setPaymentStatus(PAYMENT_STATUS.PROCESSING)
        }
        if (
          payment_status === "authorization_failed" ||
          payment_status === "payment_capture_failed"
        ) {
          setOrderStatus(false);
          setOrderId(null);
        }
        if (data.transaction_status === "payment_captured") {
          setPaymentStatus(PAYMENT_STATUS.CAPTURED);
          setOrderStatus(true);
          setOrderId(null);
          setProSliderOpen(true);
          setPostReceiptData({
            innerFields: {
              Product: "PuStack Doubts",
              "Date & Time": format(data.created_ts, "do MMM, HH:mm a"),
              "Doubts Added": formatDoubtCount(data.doubt_count),
              Amount: "₹ " + data.amount,
              Status: "Success",
            },
            outerFields: {
              Total: "₹ " + data.amount,
            },
            orderId: data.order_id,
          });
        }
      });
    };

    if (orderId) {
      const unsubscribe = orderStatusListener();
      return () => unsubscribe();
    }
  }, [orderId]);

  const tagLinesUnStandard = [
    "India's Best Teachers",
    "Unlimited Doubt Solving",
    "Live Classes",
    "Personal Mentor",
  ];

  const tagLinesStandard = [
    "Connect with top tutors in India",
    "Get your doubts cleared over video call",
    "Stay ahead in your studies with expert guidance",
  ];

  const calculateDate = (duration) => {
    // duration in 30 * months
    let newDate = new Date(
      new Date().setMonth(new Date().getMonth() + duration)
    );

    let expiryDate = null;

    if (user?.pro_expiration_date) {
      expiryDate = +new Date(user?.pro_expiration_date?.seconds * 1000);

      if (isUserPro) {
        newDate = new Date(expiryDate).setMonth(
          new Date(expiryDate).getMonth() + duration
        );
      }
    }

    return format(new Date(newDate), "MMMM do, yyyy");
  };

  const isSmallScreen = useMediaQuery({ query: "(max-width: 769px)" });

  const initPayment = async () => {
    try {
      if (proOrderCreating) return;
      document.body.style.pointerEvents = "none";
      setProOrderCreating(true);

      console.log("planIndex = ", planIndex, plans);

      const _orderData = await createDoubtOrder({
        planId: plans[planIndex].planId,
        userId: user?.uid,
        userGrade: user?.grade,
      });

      let res = await loadScript(
        "https://checkout.razorpay.com/v1/checkout.js"
      );

      console.log("_orderData - ", _orderData);

      handleClose();
      setProOrderCreating(false);

      if (!res) {
        // RazorPay SDK Failed To Load
        console.error("RazorPay SDK Failed To Load");
      } else {
        const _orderId = _orderData?.order_id;
        const doubtCount = Number(_orderData?.doubt_cunt);
        const planName = _orderData?.plan_name;
        const price = Number(_orderData?.amount);
        const orderDescription = "Order for " + doubtCount + " doubts";

        setOrderId(_orderId);

        let paymentOptions = {
          // key: "rzp_live_PHqaBBb6cbwNHF",
          key: "rzp_test_DtDgmVmIj5dm2Y",
          amount: price * 100, //in the smallest currency sub-unit.
          name: "PuStack Pro",
          order_id: _orderId, //Generate order_id using Orders API
          description: orderDescription,
          handler: function () {},
          modal: {
            ondismiss: function (e) {
              console.log("modal dismiss - ", e);
              // setOrderStatus(false);
              handleClose();
            },
          },
          prefill: {
            name: user?.name,
            contact: user?.phone_number,
            email: user?.email,
          },
          notes: {
            user_id: user?.uid,
            doubt_count: doubtCount,
            product_name: "doubts",
            plan_name: planName,
          },
        };

        let rzr_checkout = new window.Razorpay(paymentOptions);

        rzr_checkout.on("payment.failed", function (response) {
          console.log({ payment: "failed" });
        });

        rzr_checkout.open();
        document.body.style.pointerEvents = "all";
        document.body.style.overflow = "auto !important";

        proSubscriptionJourneyRef.current.logEvent("add_to_cart", {
          value: price,
          currency: "INR",
          plan_name: planName,
        });
      }
    } catch (e) {
      document.body.style.pointerEvents = "all";
    }
  };

  const generateInviteLinkAndShare = async () => {
    if (user?.uid && !generatingLink) {
      setGeneratingLink(true);
      const res = await generateInvitationLink(user?.uid);

      setReferralLink(res?.shortLink);

      setGeneratingLink(false);

      if (navigator?.canShare && res?.shortLink) {
        return await navigator.share({
          title: "PuStack Referral Program",
          text: "Invite your friends to sign up through your referral link",
          url: res?.shortLink,
        });
      } else if (res?.shortLink) {
        setOpenSharableModal(true);
      }
    }
  };

  const copyToClipBoard = () => {
    navigator.clipboard.writeText(referralLink);
  };

  const renderPlans = useCallback(() => {
    return plans?.map((plan) => (
      <div key={plan.serial_order} className="pustack__plan py-5">
        <h2 className="whitespace-nowrap">{plan.name}</h2>
        <h5>
          <span>{plan.introductoryPrice}</span> {plan.price}
        </h5>
      </div>
    ));
  }, [plans]);

  useEffect(() => {
    // setGradeMarks({});
    const controls = Object.keys(form.controls).filter((c) =>
      c.startsWith("class_")
    );
    controls.forEach((controlName) => form.removeControl(controlName));

    const getPreviousGrades = (anchorGrade) => {
      let index = gradeItems.findIndex((c) => c.value === anchorGrade);
      let end = index + 1;
      let start = end - 3 < 0 ? 0 : end - 3;
      return gradeItems.slice(start, end);
    };

    const prevGrades = getPreviousGrades(form.get("grade").value);
    prevGrades.map((gradeItem) => {
      form.registerControl(gradeItem.value, [
        isUserAlreadyAppliedForScholarship?.marks_map
          ? isUserAlreadyAppliedForScholarship.marks_map[gradeItem.value]
          : "",
        [Validators.req(), Validators.perc()],
      ]);
    });
  }, [form.get("grade").value, gradeItems, isUserAlreadyAppliedForScholarship]);

  const renderPreviousClassMarks = (disabled) => {
    const curGrade = form.get("grade").value;

    const getPreviousGrades = (anchorGrade) => {
      let index = gradeItems.findIndex((c) => c.value === anchorGrade);
      let end = index + 1;
      let start = end - 3 < 0 ? 0 : end - 3;
      return gradeItems.slice(start, end);
    };

    const prevGrades = getPreviousGrades(curGrade);

    return prevGrades.map((gradeItem, index) => {
      const lastInd = Math.ceil(7 / (prevGrades.length / (index + 1)));
      let startInd = lastInd - Math.floor(7 / prevGrades.length);
      startInd = startInd > 0 ? startInd : 1;

      if (!form.get(gradeItem.value))
        form.registerControl(gradeItem.value, [
          disabled && isUserAlreadyAppliedForScholarship?.marks_map
            ? isUserAlreadyAppliedForScholarship?.marks_map[gradeItem.value]
            : "",
          [Validators.req(), Validators.perc()],
        ]);

      return (
        <ScholarshipInput
          key={gradeItem.value}
          {...register(gradeItem.value)}
          disabled={disabled}
          // value={gradeMarks[gradeItem.value] ?? ''}
          // onChange={(e) => {
          //   let val = e.currentTarget.value;
          //   setGradeMarks(c => ({
          //     ...c,
          //     [gradeItem?.value]: val
          //   }))
          // }}
          type="number"
          required
          placeholder={gradeItem.value.split("_")[1] + "th Percentage"}
          className={`span-${startInd}-${lastInd}`}
          invalidKeys={invalidKeys}
        />
      );
    });

    // return (
    //   <>
    //     <div className="scholarship-form-input span-1-3">
    //       <input type="number" required/>
    //       <label htmlFor="">5th Marks</label>
    //     </div>
    //     <div className="scholarship-form-input span-3-5">
    //       <input type="number" required/>
    //       <label htmlFor="">6th Marks</label>
    //     </div>
    //     <div className="scholarship-form-input span-5-7">
    //       <input onClick={() => {
    //         console.log('form - ', form);
    //       }} type="number" required/>
    //       <label htmlFor="">7th Marks</label>
    //     </div>
    //   </>
    // )
  };

  useEffect(() => {
    if (
      isOpen === "scholarship" &&
      isUserAlreadyAppliedForScholarship !== null
    ) {
      setActiveIndex(1);
      // setProSliderOpen(true);
    } else if (isOpen) {
      setActiveIndex(0);
      // setProSliderOpen(true);
    }
  }, [isOpen, setActiveIndex, isUserAlreadyAppliedForScholarship]);

  useEffect(() => {
    if (
      isOpen &&
      scholarshipRef.current &&
      scholarshipRef.current.ABANDONED &&
      scholarshipJourneyRef.current
    ) {
      scholarshipJourneyRef.current.logEvent("screen_view", {
        app_name: "pustack_app",
        screen_name: "scholarship_criteria_screen",
      });
    }
  }, [isOpen, setActiveIndex, scholarshipRef, scholarshipJourneyRef]);

  return (
    <Drawer
      variant="persistent"
      // open={true}
      open={isOpen}
      anchor={isSmallScreen ? "bottom" : "right"}
      onClose={() => {
        handleClose();
        setActiveIndex(0);
        setOrderStatus(false);
      }}
      className={
        (orderStatus
          ? "pustack__pro__drawer pustack__pro__success"
          : "pustack__pro__drawer") + (isDark ? " dark" : "")
      }
      ModalProps={{ keepMounted: true }}
    >
      {user && (
        <SwipeableViews
          axis={"x"}
          scrolling={"false"}
          containerStyle={{
            transition: "transform 0.35s cubic-bezier(0.15, 0.3, 0.25, 1) 0s",
          }}
          index={activeIndex}
          style={{
            outline: "none",
            width: "100%",
            height: "100%",
            overflow: "hidden",
          }}
          ignoreNativeScroll={true}
          disabled={true}
        >
          {paymentStatus ? (
            postReceiptData ? (
              <CongratulationScreen
                handleClose={handleClose}
                postReceiptData={postReceiptData}
              />
            ) : (
              <ProcessingPaymentScreen />
            )
          ) : (
            <>
              <div className="pro__background">
                <div
                  style={{
                    backgroundImage: `url(/assets/images/film_1.jpg)`,
                    animationPlayState: isOpen ? "running" : "paused",
                  }}
                  className="pro__bg1"
                />
                <div
                  style={{
                    backgroundImage: `url(/assets/images/film_2.jpg)`,
                    animationPlayState: isOpen ? "running" : "paused",
                  }}
                  className="pro__bg2"
                />
                <div
                  style={{
                    backgroundImage: `url(/assets/images/film_3.jpg)`,
                    animationPlayState: isOpen ? "running" : "paused",
                  }}
                  className="pro__bg3"
                />
              </div>
              <div className="slider__restainer__wrapper">
                {orderStatus && isOpen && (
                  <Confetti
                    width={width}
                    height={height}
                    recycle={false}
                    tweenDuration={4000}
                    run={isOpen}
                  />
                )}
                <div
                  className="close__wrapper"
                  onClick={() => {
                    handleClose();
                    setOrderStatus(false);
                  }}
                >
                  <CloseIcon className="close__icon" />
                </div>
                <div className="slider__restainer">
                  <div className="pustack__pro__branding">
                    <Image
                      width={100}
                      height={100}
                      draggable="false"
                      src={PuStackWhiteLogo}
                      alt="PuStack Logo"
                      className="modal__logo"
                    />
                    <h6>PRO</h6>
                  </div>
                  {orderStatus && (
                    <div className="pro__user__success">
                      <h2>Congratulations!</h2>
                      <h4>Your payment has been processed, stay curious</h4>
                    </div>
                  )}
                  {!orderStatus && (
                    <div className="pustack__pro__content">
                      {(isStandardGrade
                        ? tagLinesStandard
                        : tagLinesUnStandard
                      ).map((line, index) => (
                        <div className="pustack__pro__taglines" key={index}>
                          <Image
                            width={100}
                            height={100}
                            src={CheckCircleIcon}
                            alt={`check`}
                          />
                          <h5>{line}</h5>
                        </div>
                      ))}
                    </div>
                  )}
                  {orderStatus
                    ? ""
                    : plans && (
                        <div className="plan__carousel">
                          <Carousel
                            index={planIndex}
                            NextIcon={
                              <ChevronRightIcon style={{ fill: "grey" }} />
                            }
                            PrevIcon={
                              <ChevronLeftIcon style={{ fill: "grey" }} />
                            }
                            animation="slide"
                            cycleNavigation={false}
                            autoPlay={false}
                            indicatorIconButtonProps={{
                              style: { color: "grey" },
                            }}
                            activeIndicatorIconButtonProps={{
                              style: { color: "white" },
                            }}
                            onChange={(e) => {
                              console.log("e - ", e);
                              setPlanIndex(e);
                            }}
                          >
                            {renderPlans()}
                          </Carousel>
                        </div>
                      )}
                  <div className="join__now__wrapper">
                    {orderStatus ? (
                      <button
                        className="join__now"
                        onClick={() => {
                          handleClose();
                          setOrderStatus(false);
                        }}
                      >
                        Coninue Learning
                      </button>
                    ) : isUserPro ? (
                      <button
                        className="join__now"
                        onClick={initPayment}
                        // style={{ cursor: "not-allowed" }}
                      >
                        {proOrderCreating ? (
                          <div className="circular__progress">
                            <Lottie
                              options={{
                                animationData: circleProg,
                                loop: true,
                              }}
                            />
                          </div>
                        ) : (
                          "Buy Now"
                        )}
                      </button>
                    ) : (
                      <button className="join__now" onClick={initPayment}>
                        {proOrderCreating ? (
                          <div className="circular__progress">
                            <Lottie
                              options={{
                                animationData: circleProg,
                                loop: true,
                              }}
                            />
                          </div>
                        ) : (
                          "Join Pro"
                        )}
                      </button>
                    )}
                  </div>
                  <p
                    onClick={() => {
                      // if(isUserAlreadyAppliedForScholarship) return;
                      // if(scholarshipRef.current.REJECTED || scholarshipRef.current.APPROVED){
                      // 	return setActiveIndex(3);
                      // }
                      setActiveIndex(1);
                    }}
                    className={
                      "explore__scholarship__btn" +
                      (scholarshipRef.current.status === "under_review"
                        ? " noCursor"
                        : "")
                    }
                  >
                    {scholarshipRef.current.status === "under_review"
                      ? "Your scholarship application is under review"
                      : "Explore Scholarship"}
                  </p>
                </div>
              </div>
            </>
          )}
          <>
            {scholarshipRef.current.UNDER_REVIEW && (
              <ScholarshipForm
                setOpenCriteriaModal={setOpenCriteriaModal}
                setActiveIndex={setActiveIndex}
                scholarshipRef={scholarshipRef}
              />
            )}
            {scholarshipRef.current.ABANDONED && (
              <div className="scholarship-form-wrapper">
                <div className="scholarship-form-header">
                  <ArrowBackIcon
                    style={{ cursor: "pointer" }}
                    onClick={() => setActiveIndex(0)}
                  />
                  <h2>Scholarship</h2>
                </div>
                <div className="scholarship-form-logo lowMargin">
                  <Image
                    width={100}
                    height={100}
                    src={!isDark ? BrandLogoDark : BrandLogoLight}
                    alt=""
                  />
                </div>
                <div className="scholarship-form-input-container">
                  <div className="scholarship-form-control note-item span-full">
                    <LibraryBooks />
                    <span>
                      This foundation aims to reward students for their hard
                      work.
                    </span>
                  </div>
                  <div className="scholarship-form-control note-item span-full">
                    <LibraryBooks />
                    <span>
                      Covers 100% of the Pustack pro subscription cost.
                    </span>
                  </div>
                  <div className="scholarship-form-control note-item span-full">
                    <LibraryBooks />
                    <span>
                      Requires last 3 years of excellent academic performance.
                    </span>
                  </div>
                  <div className="scholarship-form-control note-item span-full">
                    <Image
                      width={100}
                      height={100}
                      src={isDark ? ScholarshipPageDark : ScholarshipPageLight}
                      alt=""
                    />
                  </div>
                </div>
                <div className="scholarship-form-control span-full">
                  {/*<div className="scholarship-form-control-notice">*/}
                  {/*  <ErrorOutline />*/}
                  {/*  <span>Please go over the <span onClick={() => setActiveIndex(2)}>criteria</span> for the scholarship.</span>*/}
                  {/*</div>*/}
                  <button onClick={() => setActiveIndex(2)}>
                    <School />
                    <span>Apply for Scholarship</span>
                  </button>
                </div>
              </div>
            )}
            {scholarshipRef.current.APPROVED && (
              <AcceptedScreen visible={activeIndex === 1} />
            )}
            {scholarshipRef.current.REJECTED && (
              <DeniedScreen
                setOpenCriteriaModal={setOpenCriteriaModal}
                setActiveIndex={setActiveIndex}
                scholarshipRef={scholarshipRef}
              />
            )}
          </>
          {scholarshipRef.current.ABANDONED && (
            <ScholarshipForm
              setOpenCriteriaModal={setOpenCriteriaModal}
              setActiveIndex={setActiveIndex}
              scholarshipRef={scholarshipRef}
            />
          )}
          <>
            {scholarshipRef.current.APPROVED && (
              <AcceptedScreen visible={activeIndex === 3} />
            )}
            {scholarshipRef.current.UNDER_REVIEW && <UnderReviewScreen />}
            {scholarshipRef.current.REJECTED && (
              <DeniedScreen
                setOpenCriteriaModal={setOpenCriteriaModal}
                setActiveIndex={setActiveIndex}
                scholarshipRef={scholarshipRef}
              />
            )}
          </>
          {/*{!isUserAlreadyAppliedForScholarship && <div className="successful-submission">*/}
          {/*	<div*/}
          {/*	className="close__wrapper"*/}
          {/*	onClick={() => {*/}
          {/*	handleClose();*/}
          {/*	setOrderStatus(false);*/}
          {/*}}*/}
          {/*	style={{cursor: 'pointer'}}*/}
          {/*	>*/}
          {/*	<CloseIcon className="close__icon" />*/}
          {/*	</div>*/}
          {/*	<Confetti*/}
          {/*	width={'700px'}*/}
          {/*	// height={'1080px'}*/}
          {/*	tweenDuration={10000}*/}
          {/*	run={runConfetti}*/}
          {/*	recycle={false}*/}
          {/*	style={{ zIndex: 999 }}*/}
          {/*	confettiSource={{ x: 0, y: 0, w: 350, h: 0 }}*/}
          {/*	/>*/}
          {/*	<Confetti*/}
          {/*	width={'700px'}*/}
          {/*	// height={'1080px'}*/}
          {/*	tweenDuration={10000}*/}
          {/*	run={runConfetti}*/}
          {/*	recycle={false}*/}
          {/*	style={{ zIndex: 999 }}*/}
          {/*	confettiSource={{ x: 100, y: -300, w: 350, h: 500 }}*/}
          {/*	/>*/}
          {/*	<Confetti*/}
          {/*	width={'700px'}*/}
          {/*	// height={'1080px'}*/}
          {/*	tweenDuration={10000}*/}
          {/*	run={runConfetti}*/}
          {/*	recycle={false}*/}
          {/*	style={{ zIndex: 999 }}*/}
          {/*	confettiSource={{ x: 650, y: 0, w: 350, h: 0 }}*/}
          {/*	/>*/}
          {/*	<div className="successful-submission-logo">*/}
          {/*	<Image width={100} height={100} src={isDark ? PuStackWhiteLogo : PuStackLightLogo} alt="Pustack"/>*/}
          {/*	</div>*/}
          {/*	<div className="successful-submission-content">*/}
          {/*	<Lottie*/}
          {/*	style={{width: '70%'}}*/}
          {/*	options={{*/}
          {/*	animationData: ScholarshipSuccessLottie,*/}
          {/*	loop: true,*/}
          {/*}}*/}
          {/*	/>*/}
          {/*	<h3>Submitted</h3>*/}
          {/*	<p>Your application is being reviewed.</p>*/}
          {/*	</div>*/}
          {/*	<button className="successful-submission-btn" onClick={() => {*/}
          {/*		handleClose();*/}
          {/*}}>Go Back</button>*/}
          {/*	</div>}*/}
        </SwipeableViews>
      )}
      <Modal
        shouldCloseOnEsc={true}
        shouldCloseOnOverlayClick={true}
        onRequestClose={() => setOpenSharableModal(false)}
        ariaHideApp={false}
        overlayClassName="new-post-modal-overlay"
        isOpen={openSharableModal}
        className={
          isDark ? "referral-program-wrapper dark" : "referral-program-wrapper"
        }
      >
        <div
          className="close__wrapper"
          onClick={() => {
            setOpenCriteriaModal(false);
          }}
        >
          <CloseIcon className="close__icon" />
        </div>
        <h2>Qualification Criteria</h2>
        <div className="criteria-modal-note">
          <LibraryBooks />
          <span>
            This foundation aims to reward students for their hard work.
          </span>
        </div>
        <div className="criteria-modal-note">
          <LibraryBooks />
          <span>Covers 100% of the Pustack pro subscription cost.</span>
        </div>
        <div className="criteria-modal-note">
          <LibraryBooks />
          <span>Requires last 3 years of excellent academic performance.</span>
        </div>
        <PustackButton
          onClick={() => {
            setOpenCriteriaModal(false);
          }}
          isLoading={isSubmittingApplication}
        >
          Okay
        </PustackButton>
      </Modal>
    </Drawer>
  );
}

// function Item({ plan }) {
//   return (
//     <div className="pustack__plan" key={plan.name}>
//       <h2>{plan.name}</h2>
//       {/* <h5>{plan.price}</h5> */}
//       <h5>
//         <Image width={100} height={100} src={LockIcon} alt="lock" />
//       </h5>
//       <p>Valid till {plan.validity}</p>
//     </div>
//   );
// }
